import { render } from "./WorkingShiftCreateEditModal.vue?vue&type=template&id=97f8e490"
import script from "./WorkingShiftCreateEditModal.vue?vue&type=script&lang=js"
export * from "./WorkingShiftCreateEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__